import { render, staticRenderFns } from "./ErrorTooltip.vue?vue&type=template&id=6281f96c&scoped=true&"
import script from "./ErrorTooltip.vue?vue&type=script&lang=js&"
export * from "./ErrorTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTooltip.vue?vue&type=style&index=0&id=6281f96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6281f96c",
  null
  
)

export default component.exports